<template>
  <div class="row">
    <div class="col-12">
      <b-card class="shadow p-3">
        <div v-if="index === groupLength">
          <div class="row">
            <div class="col-12">
              <h6>{{ trans("global.thank_you") }}!</h6>
            </div>
            <div class="col-12 text-center">
              <b-img src="/images/icons-v4/done.png" fluid class="done-image" />
            </div>
            <div class="col-12">
              <hr />
              <b-button variant="outline-secondary" class="pull-right" @click="index--">
                {{ trans("global.review_your_answers") }}
              </b-button>
            </div>
          </div>
        </div>
        <div v-else>
          <prompt-container
            :prompt="currentPrompt.prompt"
            :type="currentPrompt.prompt.type"
            :prompt-id="currentPrompt.prompt_id"
            :page-id="pageId"
            :module-id="moduleId"
            :course-id="courseId"
            :key="currentPrompt.prompt_id"
            :is-dark-bg="false"
            :is-augmented="isAugmented"
            :text="text"
            @updatePrompt="updatePrompt"
          />
          <div class="row pt-3">
            <div class="col-4">
              <b-button variant="link" @click="index--" v-if="index > 0">{{
                trans("global.back")
              }}</b-button>
            </div>
            <div class="col-4 text-center">
              <p class="text-small text-bold mb-0 mt-2">{{ `${index + 1}/${groupLength}` }}</p>
            </div>
            <div class="col-4 text-right">
              <b-button variant="secondary" @click="index++" v-if="index < groupLength">{{
                trans("global.next")
              }}</b-button>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import PromptContainer from "./PromptContainer";

export default {
  name: "PromptGroupHorizontal",
  components: {
    PromptContainer,
  },
  props: {
    header: Object,
    prompts: Array,
    pageId: String,
    moduleId: Number,
    courseId: Number,
    isAugmented: Boolean,
    text: String,
  },
  data() {
    return {
      index: 0,
      userPrompts: this.prompts,
    };
  },
  methods: {
    updatePrompt(data) {
      this.currentPrompt.prompt.submission = data;
    },
  },
  computed: {
    groupLength() {
      return this.userPrompts.length;
    },
    currentPrompt() {
      return this.userPrompts[this.index];
    },
  },
};
</script>

<style scoped lang="scss">
.done-image {
  max-height: 200px;
}

.dark-card {
  background-color: #33405e;
}
</style>
